import { ICreateFeatureIdentityRequest } from '../../../../types/administration/features/IFeature';
import { Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { SideSheet } from '../../../../ui-toolkit';
import { SideSheetFormFooter } from '../../../shared/SideSheetFormFooter';
import { FeatureUserFormFields } from './FeatureUserFormFields';
import { useCreateFeatureIdentityMutation } from '../../../../API/administration/FeaturesAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';

interface IAddFeatureIdentityFormProps {
  onCancel: () => void;
}

const initialValues = { name: '', identityId: '', isOn: false };

export const FeatureUserForm: React.FC<IAddFeatureIdentityFormProps> = ({ onCancel }) => {
  const [createFeatureIdentity] = useCreateFeatureIdentityMutation();
  const onSubmit = useCallback(
    async (createFeatureIdentityRequest: ICreateFeatureIdentityRequest) => {
      const response = await createFeatureIdentity(createFeatureIdentityRequest);
      if (checkForMutationSuccess(response, 'Feature User Creation')) {
        onCancel();
      }
    },
    [createFeatureIdentity, onCancel]
  );
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      <Form>
        <SideSheet
          title={'New Feature User'}
          onClose={onCancel}
          footer={<SideSheetFormFooter saveButtonText={'Save and Add'} onCancel={onCancel} />}
        >
          <FeatureUserFormFields />
        </SideSheet>
      </Form>
    </Formik>
  );
};
